import React, { Component } from "react";
import { connect } from "react-redux";

import { createHighlightAction } from "actions/highlightAction";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/HighlightAction/Form";

class HighlightActionCreate extends Component {
  handleFormSubmit = data => {
    this.createHighlightAction(data);
  };

  createHighlightAction(data) {
    const { toggleNotification, toggleFullPageSpinner, createHighlightAction, history } = this.props;
    toggleFullPageSpinner(true);
    createHighlightAction(data)
      .then(() => {
        toggleNotification(true, { message: "Created HighlightAction Success", infoClassName: "is-success" });
        history.push(`/highlight-actions`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  render() {
    return <Form handleFormSubmit={this.handleFormSubmit} />;
  }
}

export default connect(
  null,
  {
    createHighlightAction,
    toggleFullPageSpinner,
    toggleNotification
  }
)(HighlightActionCreate);



// WEBPACK FOOTER //
// ./src/pages/HighlightAction/Create/index.js